type ShotProps = {
  src: string; w: number; h: number; alt: string; caption: string; sizes: string; testId: string; eager?: boolean; ratio?: string;
};

export function Shot({ src, w, h, alt, caption, sizes, testId, eager, ratio = "aspect-[6/5]" }: ShotProps) {
  return (
    <figure className="m-0 min-w-0 flex flex-col">
      <a href={src} target="_blank" rel="noopener noreferrer" className={`aq-shot block ${ratio} rounded-xl border border-[hsl(var(--aq-line))] bg-white/80 overflow-hidden`} data-testid={testId}>
        <img src={src} width={w} height={h} loading={eager ? "eager" : "lazy"} decoding="async" alt={alt} sizes={sizes} className="w-full h-full object-contain block" />
      </a>
      <figcaption className="w-full text-sm text-[hsl(var(--aq-muted))] mt-2 leading-snug">{caption}</figcaption>
    </figure>
  );
}

const STEPS = [
  { n: "1", t: "Add what you have", d: "Photos, drawings or a description. One is enough.", shot: { testId: "img-upload", src: "/campaign/auto-quote-upload.webp", w: 930, h: 858, alt: "The Auto Quote upload screen", caption: "The upload screen." } },
  { n: "2", t: "Build the job scope", d: "Your input becomes a detailed job description, ready for pricing.", shot: { testId: "img-progress", src: "/campaign/auto-quote-progress.webp", w: 536, h: 485, alt: "Auto Quote creating the project description before pricing", caption: "Creating the job description." } },
  { n: "3", t: "Check, edit, send", d: "Change any quantity or rate before it goes out.", shot: { testId: "img-completed", src: "/campaign/auto-quote-completed.webp", w: 895, h: 867, alt: "Completed Auto Quote screen with sections such as Preparation, Demolition and Substructure and priced lines", caption: "Editable itemised quote. Independent example." } },
];

export function AutoQuoteShowcase() {
  return (
    <section id="how-it-works" className="aq-section scroll-mt-20" data-testid="section-showcase" aria-labelledby="how-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <p className="aq-eyebrow">How it works</p>
        <h2 id="how-heading" className="aq-h2">Three steps. Real screens.</h2>
        <ol className="mt-8 grid gap-8 md:grid-cols-3 list-none p-0" aria-label="Auto Quote steps">
          {STEPS.map((s) => (
            <li key={s.n} className="min-w-0 flex flex-col">
              <div className="flex items-start gap-3 mb-4 md:min-h-[4.5rem]">
                <span className="aq-num" aria-hidden="true">{s.n}</span>
                <div>
                  <h3 className="font-bold text-lg leading-tight text-[hsl(var(--aq-navy))]">{s.t}</h3>
                  <p className="text-sm text-[hsl(var(--aq-muted))] mt-1">{s.d}</p>
                </div>
              </div>
              <Shot {...s.shot} sizes="(min-width: 768px) 32vw, 100vw" />
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
